import React from "react"

const License = props => {
    return (
        <div className="bodyContainer">
            <div>Asahi End-User License Agreement</div>
            <div> Last Updated: 10-24-2020 </div>
            This End-User License Agreement (Agreement) is between the business
            or individual accepting this Agreement (this business or individual
            being you) and [Yoon Jung] (Developer). This Agreement is solely
            between you and Developer, and governs your use of Developer's
            software application and the corresponding services it provides
            (together, along with the associated documentation, proprietary, or
            intellectual property: the App). Review this Agreement completely.
            You agree to be bound by the terms of this Agreement when you click
            "Accept" or otherwise download, install, copy, or use the App, and
            must accept this Agreement before doing so. If you do not agree to
            the terms of this Agreement, you must click "Decline" and must not
            download, install, copy or use the App. 1. The App 1.1 The App will
            provide you with the ability to: [describe the App functionality and
            associated services]. 1.2 Developer grants you a limited,
            non-exclusive, non-transferable, non-sublicensable, revocable
            license during the Term (defined below) of this Agreement to use the
            App solely for your internal business purposes. You will not
            otherwise distribute, lease, rent, host, sublicense, transfer, sell,
            export, modify, reverse engineer, decompile, copy, benchmark, create
            derivative works from, or attempt to derive the source code for the
            App. This license does not grant you any rights to Developer's (or
            any other third party's) trademarks, service marks, logos, trade
            dress, proprietary, or other intellectual property unless provided
            with the App. Developer reserves to itself (or applicable third
            parties) all right, title, interest, and license (express or
            implied) to the App that are not specifically granted to you under
            this Agreement. You will preserve and display any proprietary
            notices, markings, or branding associated with use of the App. 1.3
            The App may update automatically from time-to-time, and you may be
            required to accept these updates to continue using the App.
            Developer may perform maintenance on the App, which may result in
            service interruptions or delays from time-to-time. Developer may not
            support older versions of the App. You are solely responsible for
            obtaining all equipment and services (e.g., Internet connectivity)
            necessary to access and use the App. 2. Fees You will pay Developer
            a monthly fee for your use of the App, which will be automatically
            collected through the payment method you select during set-up for
            the App. You are responsible for payment of all sales, use, excise,
            or similar taxes (excluding taxes based on Developer's income)
            imposed by federal, state, or local tax authority. You must notify
            Developer of any billing errors within 120 days from when an error
            appears on your invoice, after which time period you release
            Developer from all liability for Losses (defined below) resulting
            from these errors. 3. Term This Agreement commences when you accept
            or otherwise download, install, copy, or use the App; and will
            continue month-to-month until terminated (this period of time is the
            Agreement's Term). 4. Suspension and Termination 4.1 Developer may
            promptly suspend or terminate your use of the App if (1) you violate
            this Agreement's terms; (2) Developer believes your use of the App
            may damage its reputation or intellectual property rights; (3)
            Developer suspends or terminates its agreement(s) with any third
            party involved in providing the App; (4) you exceed normal and
            reasonable usage for the App; (5) you experience a bankruptcy or
            insolvency event; or (6) you are using the App for any fraudulent,
            illegal, or unauthorized purpose, or engage in willful misconduct
            with respect to use of the App. 4.2 You may terminate this Agreement
            at any time and for any reason (without cause) by providing notice
            to Developer. Your termination will be effective at the end of the
            then current month or billing period in which you give notice. You
            will not receive a refund for the billing period in which you
            terminate this Agreement. 5. Confidentiality, Data, and Ideas 5.1
            Neither of us will disclose non-public information about the other's
            business; including, without limitation, the terms of this
            Agreement, technical specifications (whether related to the App or
            otherwise), customer lists, or information relating to a party's
            operational, strategic, or financial matters (together, Confidential
            Information). Confidential Information does not include information
            that (1) is or subsequently becomes publicly available (through no
            fault of the recipient); (2) the recipient lawfully possesses before
            its disclosure; (3) is independently developed without reliance on
            the discloser's Confidential Information; or (4) is received from a
            third party that is not obligated to keep it confidential. Each of
            us will implement and maintain reasonable safeguards to protect the
            other's Confidential Information. 5.2 Neither of us may disclose the
            other's Confidential Information except (1) to our respective
            directors, officers, employees, or representatives that need to know
            it in order to perform our obligations under this Agreement; (2) in
            response to a subpoena or court order; or (3) as required by
            applicable law, rule, or regulation. 5.3 Developer may use data or
            information obtained through the App to provide its services, for
            research and development, or in aggregated and anonymized form to
            provide services generally; all subject to applicable Laws (defined
            below). Information Developer collects about you or your consumers
            is subject to Developer's privacy policy, which is accessible at
            [link to privacy policy]. 5.4 You may provide, or Developer may
            invite you to provide, comments or ideas about the App (including,
            without limitation, improvements to it) (together, Ideas). By
            submitting any Ideas, you agree that (1) they are not Confidential
            Information; (2) they are not subject to any use or disclosure
            restrictions (express or implied); (3) you claim no rights in them;
            and (4) Developer has no obligation to notify or compensate you in
            connection with their disclosure or use. You release Developer from
            all liability or obligations that may arise from the receipt,
            review, disclosure, or use of any Idea that you submit. 6. Account
            You will be required to register for an account with Developer to
            use the App. You will provide us with accurate information when
            setting-up your account, and will maintain your account with current
            information. You will be responsible for establishing safeguards
            designed to prevent unauthorized access to, disclosure, use, or
            alteration of your account (safeguards may include, without
            limitation, user names, passwords, security questions and answers,
            or other credentials). You must notify Developer if you discover a
            security breach involving your account or the App. You are
            responsible for any unauthorized access to, disclosure, use, or
            alteration of your account, the App, or other transaction
            information that arises through your systems or account. It is your
            responsibility to back-up and maintain the accuracy and completeness
            of any content created, derived from, stored, or accessed through
            your account or your use of the App (content may include, without
            limitation, transaction information, text, images, graphics, or
            photos). 7. Risk Allocation 7.1 The App is provided to you "as-is"
            and "as-available." You are solely responsible for determining if
            the App meets your needs. Developer disclaims all warranties
            (express or implied) related to your account or the App; including,
            without limitation, warranties of security, merchantability, fitness
            for a particular purpose, non-infringement, accuracy, and
            uninterrupted or error-free operation. Developer is not responsible
            for any disclosures, modifications, deletions, or other errors that
            arise in connection with your use of the App due to its interaction
            with other applications or their content. 7.2 You will indemnify
            Developer, its directors, officers, employees, agents, subsidiaries,
            and affiliates against any third party claims for losses, damages,
            costs, or expenses (including reasonable attorneys' fees) (together,
            Losses) that result from your use or misuse of the App, or your
            breach of this Agreement. Developer may assume the defense of any
            third party claims that you must indemnify it for (at your expense),
            and you will cooperate with the defense of these claims. You will
            not settle any third party claims involving more than the payment of
            money without Developer's written consent. 7.3 To the extent
            permitted by applicable law, Developer will not be liable to you for
            any lost profits, revenues, or business opportunities, nor any
            exemplary, punitive, special, indirect, incidental, or consequential
            damages; regardless of whether these damages were foreseeable or
            either of us was advised they were possible. 7.4 Developer's total,
            aggregate liability to you for all Losses arising from any cause
            (regardless of the form of action or legal theory) in connection
            with this Agreement will not exceed the amount of fees you've paid
            to Developer during the 3 months prior to a Loss. 8. Communications
            You authorized Developer to communicate with you electronically or
            otherwise using the contact information you provide to it (e.g.,
            without limitation, via your account, the Internet, email, text, or
            live agent or automated calls to your mobile or other phone, even if
            these numbers appear on a Do Not Call or other non-solicitation
            registry). You are responsible for any fees charged by you
            communications provider for phone, text, or email communications
            that Developer sends to you. 9. General 9.1 You represent and
            warrant that you have authority to enter into this Agreement,
            creating performance obligations that are legally enforceable
            against you. 9.2 Developer may modify this Agreement from
            time-to-time and will provide you with notice when these
            modifications occur (notification may be through the App, email, a
            website, changes to the date shown at the top of this Agreement, or
            other electronic means). Your continued use of the App indicates
            your acceptance of any modifications to this Agreement. You must
            stop using and uninstall the App if you do not agree to any
            modifications that are made to this Agreement. 9.3 Each of us will
            comply with the laws, rules, and regulations (together, Laws) that
            apply to our respective performance under this Agreement; including,
            without limitation, laws related to the collection and use of
            consumer information obtained via the App. You will follow the
            requirements of all user documentation provided for the App. You
            will not use your App to access, store, or transmit materials that
            are tortious, libelous, or offensive; contain malicious code,
            viruses, time bombs, Trojan horses, bots, scrips or other programs;
            or infringe third parties' intellectual property rights. 9.4 This
            Agreement is governed by New York law, without regard to its
            conflicts or choice of law statutes. The courts in or for Suffolk
            County, New York are proper venue for any proceedings in connection
            with this Agreement. Both of us waive our rights to a trial by jury
            in connection with this Agreement. 9.5 This is the entire agreement
            between us, and supersedes any prior agreements related to its
            subject matter. Any sections or terms of this Agreement that are, or
            become, invalid or unenforceable will be severed; and the remaining
            terms will continue in effect. Developer is not waiving any of its
            rights under this Agreement if it delays their exercise or fails to
            exercise them. We are independent contractors. This Agreement does
            not create an agency, partnership, or joint venture of any kind. 9.6
            You may not assign this Agreement without Developer's written
            consent, which assignment is voidable by the Developer; however,
            Developer may assign this Agreement without notice to you or your
            consent. 9.7 You may contact Developer at: [lys941121@gmail.com]
        </div>
    )
}

export default License
